import React, { useState, useEffect } from 'react'
import VerCupon from './VerCupon'
import SubirEditCupon from './SubirEditCupon'
import Eliminar from '../componentes/Eliminar'
import Header from '../componentes/Header';
import useTraeDatos from '../hooks/useTraeDatos';
import { Titulos, peticionDelete } from '../hooks/Funciones'
import moment from 'moment'

const CuponesAdmin = ({ urlcupon, titulo }) => {

	const [tituloPag, setTituloPag] = useState(titulo)
	const [registroSelect, setRegistroSelect] = useState({})
	const [funcion, setFuncion] = useState('ver')
	const [cupon, setcupon] = useTraeDatos(urlcupon)
	const TitulosPagina = ['Ver cupon', 'Crear cupon', 'Editar cupon', 'Eliminar cupon', 'cupon']
	const [copiaArray, setCopiaArray] = useTraeDatos(urlcupon)
	const [busqueda, setBusqueda] = useState('')

	const seleccionaRegistro = (dato, funcion) => e => {
		setRegistroSelect({ ...dato, imagePrev: dato.imagen, fechatermino: moment(dato.fechatermino).toDate() })
		setFuncion(funcion === 'eliminar' ? 'eliminar' : 'editar')
	}

	const peticionDeletee = () => { peticionDelete(registroSelect, urlcupon, cupon, setcupon, setFuncion) }
	useEffect(() => { Titulos(funcion, setTituloPag, TitulosPagina) }, [funcion])

	const RecibeBusqueda = e => {
		setBusqueda(e.target.value)
		filtrar(e.target.value)
	}

	const filtrar = (termino) => {
		let resultado = copiaArray.filter((item) => {
			if (item.nombre.toLowerCase().includes(termino.toLowerCase())) {
				return item
			}
		})
		setcupon(resultado)
	}

	const ReiniciarPaginacion = () => {
		setcupon(copiaArray)
		setBusqueda('')
	}


	return (
		<div>
			<Header 
				titulo={tituloPag} 
				funcion={funcion} 
				setFuncion={setFuncion} 
				Pagina={'cupon'} 
				RecibeBusqueda={RecibeBusqueda} 
				busqueda={busqueda} 
				resetBusq={ReiniciarPaginacion}
			/>
			{funcion === 'crear' ?
				<SubirEditCupon
					baseUrl={urlcupon}
					setFuncion={setFuncion}
					data={cupon}
					setData={setcupon}
					TituloBtn={tituloPag}
					setTituloPag={setTituloPag}
					funcion={funcion} />
				: null}
			{funcion === 'editar' ?
				<SubirEditCupon
					baseUrl={urlcupon}
					setFuncion={setFuncion}
					data={cupon}
					setData={setcupon}
					TituloBtn={tituloPag}
					setTituloPag={setTituloPag}
					registroSelect={registroSelect}
					funcion={funcion} />
				: null}
			{funcion === 'ver' ?
				<VerCupon
					data={cupon}
					seleccionaRegistro={seleccionaRegistro}
					setFuncion={setFuncion}
					setRegistroSelect={setRegistroSelect}
					baseUrl={urlcupon}
				/>
				: null}
			{funcion === 'eliminar' ?
				<Eliminar
					nombre={'Operador'}
					select={registroSelect}
					setFuncion={setFuncion}
					peticionDelete={peticionDeletee} />

				: null}
		</div>
	)
}

export default CuponesAdmin